<template>
    <div class="main-container px-1 md:px-8">
        <Toast />
        <AdminIndex v-if="isSuperAdmin" />
        <UserIndex v-else />
    </div>
</template>

<script setup>
import { computed } from "vue";
import { useStore } from 'vuex';

import UserIndex from './UserIndex.vue';
import AdminIndex from './AdminIndex.vue';

const store = useStore();
const isSuperAdmin = computed(() => store.getters.isSuperAdmin);

</script>

<style scoped>
/* Add custom styles if needed */
</style>